import { I18n } from "i18n-js";

import { Language } from "@ctypes";
import { translations } from "./translations";

const i18n = new I18n(translations);

i18n.enableFallback = true;
i18n.translations = translations;

i18n.locale = Language.En;
i18n.defaultLocale = Language.En;

export { i18n };
